import { useEffect } from 'react';

import { IUseAlertOrderLimit } from './types';

const useAlertOrderLimit = ({
  calculateCartTotal,
  alertOrderLimit,
  alertOnExceeded = true,
  checkoutPriceLimit,
  setCartPriceLimitExceeded,
  isCatering,
}: IUseAlertOrderLimit) => {
  useEffect(() => {
    if (!isCatering && calculateCartTotal() > checkoutPriceLimit) {
      if (alertOnExceeded) {
        alertOrderLimit();
      }
      setCartPriceLimitExceeded(true);
      return;
    }

    setCartPriceLimitExceeded(false);
  }, [
    calculateCartTotal,
    alertOrderLimit,
    alertOnExceeded,
    checkoutPriceLimit,
    isCatering,
    setCartPriceLimitExceeded,
  ]);
};

export default useAlertOrderLimit;
